// this middleware is only for backwards compatibility and should be deleted once enough time has passed
// it was created October 29th, 2025
// TODO: Remove after March 1st, 2026
export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path.includes('/categorías') || to.path.includes('/categor%C3%ADas')) {
    const newPath = to.path.replace('/categorías', '/categorias').replace('/categor%C3%ADas', '/categorias')
    return navigateTo({
      path: newPath,
      query: to.query,
      hash: to.hash
    })
  }
  if (to.path.includes('/catégories') || to.path.includes('/cat%C3%A9gories')) {
    const newPath = to.path.replace('/catégories', '/categories').replace('/cat%C3%A9gories', '/categories')
    return navigateTo({
      path: newPath,
      query: to.query,
      hash: to.hash
    })
  }
})
